import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController'
import { ButtonAPI, ImageAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import ConfigurationService from '../../services/configuration-service';
import { Routes } from '../../codegen/constants/routes';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { PatientHttpService } from '../../services/patient-http-service';
import { Value } from '@philips-internal/oswald-ui-core';
import { AppAliases, NaturalPersonLinkSolicitationAliases } from '../../codegen';
import { HttpResponse, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { MessageResponseInterface, StatusResponseInterface } from './natural-person-link-solicitation-interfaces'
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import './natural-person-link-solicitation-controller.css';

@Controller({ component: NaturalPersonLinkSolicitationAliases.SOLICITATION_LAYOUT, fragment: AppAliases.NATURAL_PERSON_LINK_SOLICITATION })
class NaturalPersonLinkSolicitaionController extends BaseController {
  @Inject(NaturalPersonLinkSolicitationAliases.TITLE_IMAGE)
    ImageHeader!: ImageAPI;

  @Inject(NaturalPersonLinkSolicitationAliases.LOGO_IMAGE)
    logoImage!: ImageAPI;

  @Inject(NaturalPersonLinkSolicitationAliases.ACCEPT_BUTTON)
    acceptButton!: ButtonAPI;

  @Inject(NaturalPersonLinkSolicitationAliases.DENY_BUTTON)
    denyButton!: ButtonAPI;

  @Inject(NaturalPersonLinkSolicitationAliases.SOLICITATION_TEXT)
    text!: TextAPI;

  @Inject(NaturalPersonLinkSolicitationAliases.LOGIN_BUTTON)
    loginButton!: ButtonAPI;

  @OnMount({ target: [NaturalPersonLinkSolicitationAliases.SOLICITATION_LAYOUT] })
  onMount(): void {
    ConfigurationService.getConfigurationData().then(layoutData => {
      this.ImageHeader.setSrc(layoutData.dsUrlLogoHeaderLogin);
    });

  }

  @OnMount(NaturalPersonLinkSolicitationAliases.LOGO_IMAGE)
  handleLogoImageLoading(event: MountEvent): void {
    const imageAPI = event.target as ImageAPI;
    ConfigurationService.getConfigurationData().then(layoutData => {
      imageAPI.setSrc(layoutData.dsLogoLogin);
    });
  }

  @OnClick({ target: NaturalPersonLinkSolicitationAliases.LOGIN_BUTTON })
  onClickLoginButton(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  @OnMount(NaturalPersonLinkSolicitationAliases.SOLICITATION_TEXT)
  handleMessage(event: MountEvent): void {
    const textAPI = event.target as TextAPI;
    const body = {
      ieAction: 'PF'
    } as Record<string, Value>;
    PatientHttpService.get(APPLICATION_ENDPOINTS.GET_CUSTOM_MESSAGE, body).then((httpResponse: HttpResponse<unknown>) => {
      const message: string = (httpResponse?.body as MessageResponseInterface)?.message ?? 'patient.link-solicitation';
      textAPI.setValue(message);
    });
  }

  @OnClick({ target: NaturalPersonLinkSolicitationAliases.ACCEPT_BUTTON })
  onClickAcceptButton(): void {
    if (this.historyService.getCurrentRoute() == Routes.NATURAL_PERSON_LINK) {
      this.onClickAction('A');
    }
  }

  @OnClick({ target: NaturalPersonLinkSolicitationAliases.DENY_BUTTON })
  onClickDenyButton(): void {
    if (this.historyService.getCurrentRoute() == Routes.NATURAL_PERSON_LINK) {
      this.onClickAction('D');
    }
  }

  onClickAction(actionSolic: string): void {
    if (this.historyService.getCurrentRoute() == Routes.NATURAL_PERSON_LINK) {
      this.acceptButton.setEnabled(false);
      this.denyButton.setEnabled(false);
      const body = {
        actionSolic: actionSolic,
        token: this.historyService.getCurrentRouteQueryParams()['token']
      } as Record<string, Value>;

      PatientHttpService.post(APPLICATION_ENDPOINTS.POST_LINK_SOLICITATION, body).then((httpResponse: HttpResponse<unknown>) => {
        this.postResponse(httpResponse?.body as StatusResponseInterface);
      });
    }
  }

  postResponse(response: StatusResponseInterface): void {
    this.setButtonVisibilities();
    this.changeLogoIcon(response);
    this.showMessage(response);
  }

  setButtonVisibilities(): void {
    this.acceptButton.setVisible(false);
    this.denyButton.setVisible(false);
    this.loginButton.setVisible(true);
  }

  changeLogoIcon(response: StatusResponseInterface): void {
    const status = response?.status ?? 'FAIL';
    const icon = status == 'SUCCESS'? '/static/assets/icons/check-green.svg' : '/static/assets/icons/cancel.svg';
    this.logoImage.setSrc(icon);
  }

  showMessage(response: StatusResponseInterface): void {
    const expressions: {
      [key: string]: string
    } = {
      'EXPIRED_TOKEN': 'patient.token.expirado-invalido',
      'FAIL': 'patient.messages.server-error',
      'SUCCESS': 'patient.forget.password.request.success'
    }
    this.text.setValue(MessageService.translate(expressions[response?.status ?? 'FAIL']));
  }

}

export default NaturalPersonLinkSolicitaionController;
